import { Component, OnInit } from '@angular/core';
import { StoreFsrhDetailsService } from '../services/store-fsrh-details.service';
import {ElementRef, ViewChild, AfterViewInit} from '@angular/core';


@Component({
  selector: 'app-recommendations',
  templateUrl: './recommendations.component.html',
  styleUrls: ['./recommendations.component.scss']
})
export class RecommendationsComponent implements OnInit {

  formResult1;
  formResult2;
  within5DaysAfterOvulation;
  pregnancyTestAdvised: boolean;
  oralECUnlikelyToBeEffective: boolean;
  offerQuickStartContraception: boolean;
  eligibleForCuIUD: boolean;
  takingEnzymeInducer: boolean;
  asthmaManagedWithglucocorticoids: boolean;
  bmi: number;
  weightInKg: number;
  patientDets;
  useOfCuIUD: boolean;
  wasPeriodNormal: boolean;
  fiveDaysAfterOvulationDate: Date;
  today: Date;
  breastFeeding: boolean;
  HRT: boolean;
  constructor(private formResult: StoreFsrhDetailsService) {
    this.formResult1 = formResult.formResult1;
    this.formResult2 = formResult.formResult2;
    this.pregnancyTestAdvised = formResult.pregnancyTestAdvised;
    this.oralECUnlikelyToBeEffective = formResult.oralECUnlikelyEffective;
    this.offerQuickStartContraception = formResult.offerQuickStartContraception;
    this.eligibleForCuIUD = formResult.eligibleForCuIUD;
    this.takingEnzymeInducer = formResult.takingEnzymeInducer;
    this.asthmaManagedWithglucocorticoids = formResult.asthmaManagedWithglucocorticoids;
    this.bmi = formResult.bmi;
    this.weightInKg = formResult.weightInKg;
    this.patientDets = formResult.patientDets;
    this.useOfCuIUD = formResult.useOfCuIUD;
    this.wasPeriodNormal = formResult.wasPeriodNormal;
    this.within5DaysAfterOvulation = formResult.within5DaysAfterOvulation;
    this.fiveDaysAfterOvulationDate = new Date(formResult.fiveDaysAfterOvulationDate);
    this.today = new Date(formResult.today);
    this.breastFeeding =  formResult.breastFeeding;
    this.HRT =  formResult.HRT;


  }

  ngOnInit() {
  }
}
